import React, { useEffect, useState, useMemo } from "react";
import { showServicesApi } from "../../../../services/Admin/service";
import TableC from "../../../../components/Admin/TableC";
import { Button } from "@mui/material";
import LoadingProgress from "../../../../components/LoadingProgress";
import {RouteAdmin} from "../../../../routes/RouteAdmin";
import Card from "../../../../components/Admin/Card";

export default function Management() {

    const [servicios, setServicios] = useState(null)
    const [loading, setLoading] = useState(true)
    const [globalFilter, setGlobalFilter] = useState("")

    const columns = useMemo(
        () => [
            {
                Header: "NOMBRE",
                accessor: "name",
            },
            {
                Header: "TIPO DE PRECIO",
                accessor: "serviceType",
            },
            {
                Header: "PRECIO",
                accessor: "pvp",
            },
            {
                Header: "IVA (%)",
                accessor: "iva",
            },
            {
                Header: "MOSTRAR",
                accessor: "mostrar",
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }
        ],
        []
    )

    useEffect(() => {
       getServicesType()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getServicesType = async () =>{
        setLoading(true)

        showServicesApi().then(resp => {
            const temp = resp.data.data.map((doc) => {
                let href = `${RouteAdmin.TIPO_SERVICIOS_EDIT.path}/${doc.id}`;
                var mostrar = "No";

                if (doc.isActive) {
                    mostrar = "Sí";
                }

                return {
                    ...doc,
                    id: doc.id,
                    name: doc.name,
                    iva: doc.iva,
                    pvp: doc.pvp,
                    mostrar:mostrar,
                    actions: (
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            href={href}
                            sx={{
                                borderRadius: 2,
                                paddingLeft: 2,
                                paddingRight: 2,
                                textTransform: 'none',
                                fontWeight: 500,
                                boxShadow: 'none'
                            }}
                        >
                            Editar
                        </Button>
                    ),
                    serviceType: doc.serviceType === 'KEY_UNIT' ? 'Por unidad' : 'Por hora',
                }
            })
            setServicios(temp)
            setLoading(false)
        }).catch(err => {
            console.error(err)
        })
    }

    // --- Filtro global aplicado a servicios ---
    const filteredServicios = useMemo(() => {
        if (!globalFilter) return servicios || [];
        const search = globalFilter.toLowerCase();
        return (servicios || []).filter(row =>
            Object.values(row).some(
                val =>
                    typeof val === 'string' && val.toLowerCase().includes(search)
            )
        );
    }, [servicios, globalFilter]);

    return (
        <Card>
            <div className="cointainer">
                <h1>Servicios / Productos</h1>
                <div style={{ float: "right" }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ width: 200 }}
                        href={RouteAdmin.TIPO_SERVICIOS_CREATE.path}
                    >
                        Añadir
                    </Button>
                </div>
            </div>

            <LoadingProgress loading={loading}/>
            {!loading && (
                <TableC
                    columns={columns}
                    data={filteredServicios}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                />
            )}
        </Card>
    )
}
